import React from 'react';

interface ClientStatusBadgeProps {
  isActive: boolean;
  isFeatured?: boolean;
}

export const ClientStatusBadge: React.FC<ClientStatusBadgeProps> = ({
  isActive,
  isFeatured,
}) => {
  const badges = [];

  if (isActive) {
    badges.push(
      <span
        key="active"
        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
      >
        Active
      </span>
    );
  } else {
    badges.push(
      <span
        key="inactive"
        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800"
      >
        Inactive
      </span>
    );
  }

  if (isFeatured) {
    badges.push(
      <span
        key="featured"
        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800"
      >
        Featured
      </span>
    );
  }

  return <div className="flex gap-2">{badges}</div>;
};
